import './delay_render_chart_view.js.coffee';# Added by Script 
import './timeline_chart_view.js.coffee'
Namespace 'CustomerVisualMode.Charts'

class CustomerVisualMode.Charts.AverageFirstBotResponseChartView extends CustomerVisualMode.Charts.DelayRenderChartView
  className: 'grid-item full-width-chart average_first_bot_response'
  @NAME: 'average_time_to_first_bot_reply'

  initialize: ({widget, data, session, isReadOnly, isResponsive}) ->
    @barMenu = new Common.Dashboard.Charts.BarMenuView(exportable: true)
    title = I18n.t('customer_visual_mode.charts.average_first_bot_response.title')
    description = I18n.t('customer_visual_mode.charts.average_first_bot_response.description')
    times = data.map((value) -> value.time)
    series = @_createSeries(data)
    @timelineChart = new CustomerVisualMode.Charts.TimelineChartView({times, series})
    @listenTo(@timelineChart, 'timeline:click:line', @_openDrilldown)
    @dateRangeBuilder = new Common.Dashboard.Filters.DateRangeBuilder(session)
    super({widget, title, description, data, session, isReadOnly, isResponsive})

  render: =>
    super()
    @$el.find('.chart').append(@timelineChart.render().el)
    @$el.find('.chart-actions').children().last().before(@barMenu.render().el)

  _renderChart: ->
    @chart = @timelineChart.renderChart()
    @barMenu.chart = @chart
    @chart

  _createSeries: (data) ->
    [
      {
        name: I18n.t('customer_visual_mode.charts.average_first_bot_response.average_time'),
        data: data.map((value) -> {y: value.count, time: value.time})
      }
    ]

  _openDrilldown: (drilldownValue, timeInSeconds) ->
    super({
      date: @dateRangeBuilder.build(timeInSeconds),
      dimensions: ['metrics', 'date'],
      name: 'Avg first response',
      metric_names: ['first_bot_response_since_creation'],
      drilldown_code: 'ticket_with_metrics',
      timezone: moment().format('Z')
    })
